import clsx from 'clsx';
import type { ReactNode } from 'react';

export type CardHeaderInverseTitleSize = 'default' | 'item';

export interface CardHeaderInverseProps {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    title: ReactNode;
    subtitle?: ReactNode;
    eyebrow?: ReactNode;
    badge?: ReactNode;
    titleId?: string;
    titleSize?: CardHeaderInverseTitleSize;
    className?: string;
}

const CardHeaderInverse = ({
    as: Tag = 'h2',
    title,
    subtitle,
    eyebrow,
    badge,
    titleId,
    titleSize = 'default',
    className,
}: CardHeaderInverseProps) => {
    const titleElement = (
        <Tag
            id={titleId}
            className={clsx(
                'card-header-inverse-title',
                titleSize === 'item' && 'card-header-inverse-title--item',
            )}
        >
            {title}
        </Tag>
    );

    return (
        <div className={clsx('card-header-inverse', className)}>
            {badge ? (
                <div className="card-header-inverse-row">
                    <div className="card-header-inverse-content">
                        {eyebrow ? <span className="card-header-inverse-eyebrow">{eyebrow}</span> : null}
                        {titleElement}
                        {subtitle ? <p className="card-header-inverse-subtitle">{subtitle}</p> : null}
                    </div>
                    <div className="card-header-inverse-aside">
                        <span className="card-header-inverse-badge">{badge}</span>
                    </div>
                </div>
            ) : (
                <>
                    {eyebrow ? <span className="card-header-inverse-eyebrow">{eyebrow}</span> : null}
                    {titleElement}
                    {subtitle ? <p className="card-header-inverse-subtitle">{subtitle}</p> : null}
                </>
            )}
        </div>
    );
};

export default CardHeaderInverse;
